export const DOMAIN = 'on-running.com'
export const CUSTOMER_SERVICE_SUBDOMAIN = `customer-service.${DOMAIN}`
export const FILTER_PAGE_PATH = 'explore'
export const FILTER_PAGE_MENS_PATH = 'explore/mens'
export const FILTER_PAGE_WOMENS_PATH = 'explore/womens'
export const SHOE_FINDER_PATH = 'shoe-finder'
export const SHIPPING_RETURNS_PATH = 'shipping_and_returns'
export const SIZE_GUIDE_PATH = 'size_guide'
